import { useEffect, useState } from 'react';
import { debugLog } from '../../utils/common';
import { walletReferralCookieName, walletReferralQueryKey } from '../../utils/constants';
import { getCookie, setCookie } from '../../utils/cookie';
import { isBrowser } from '../../utils/trick';
import { userInfoStore } from '../../store/userInfo';
import { invoke } from '../../wallet-hub/misc';
import { getResultFromResponse, runAsyncSafe } from '@web3/utils';
import { getThisUserInviteeCode } from '../../api';

if (isBrowser) {
  const searchParams = new URLSearchParams(window.location.search);
  const referral = searchParams.get(walletReferralQueryKey);
  debugLog('wallet referral', referral);
  if (referral) {
    setCookie(walletReferralCookieName, referral);
  }
}

export const useReferralCode = (resetDefault: boolean) => {
  const [referral, setReferral] = useState('');

  useEffect(() => {
    invoke(async () => {
      if (resetDefault && userInfoStore.state.isLogin) {
        const [err, res] = await runAsyncSafe(getResultFromResponse(getThisUserInviteeCode()));
        if (res?.referralCode) {
          setReferral(res.referralCode);
        } else {
          setReferral(getCookie(walletReferralCookieName) || '');
        }
      }
    });
  }, [resetDefault]);

  return [referral, setReferral] as const;
};
